import 'angular-scroll';

export default 'duScroll';



// WEBPACK FOOTER //
// ./src/common/wrappers/angular-scroll.js